// extracted by mini-css-extract-plugin
export default {"changeBranchText":"horizontalNav_changeBranchText__D-KKS"};